import * as types from '../mutation-types'; 
import {
    get_categories,get_items
} from '@/api/item';


export const state = {
  categories: [], 
  loading: false,
  items:[],
  item_loading: false,
  meta_item:{},
  view_item: {}

}
 
export const getters = {
    loading: state => state.loading, 
    items: state => state.items, 
    categories: state => state.categories, 
    meta_item: state => state.meta_item, 
    item_loading: state => state.item_loading, 
    view_item: state => state.view_item, 
} 
export const mutations = {
  [types.CATEGORY] (state,payload) {
    state.loading = true;
  },
  [types.CATEGORY_FAIL] (state,payload) {
    state.loading = false;
    state.categories = [];
  },
  [types.CATEGORY_SUCCESS] (state,payload) {
    state.loading = false;
    state.categories = payload;
  },
  [types.ITEM] (state,payload) {
    state.item_loading = true;
  },
  [types.ITEM_FAIL] (state,payload) {
    state.item_loading = false;
    state.meta_item ={}
    state.items = [];
  },
  [types.ITEM_SUCCESS] (state,payload) {
    state.item_loading = false;
    state.meta_item =payload.meta
    state.items = payload.items;
  }, 
  setViewItem (state,payload) { 
    state.view_item = payload
  },
} 
export const actions = {
  async fecthCategory ({ commit }, payload) { 
    commit(types.CATEGORY);
   try {
       const data = await get_categories(payload); 
       commit(types.CATEGORY_SUCCESS,data)
   } catch (error) { 
    commit(types.CATEGORY_FAIL);
   };

  },
  async fetchItem ({ commit }, payload) { 
    commit(types.ITEM);
   try {
       const data = await get_items(payload); 
       commit(types.ITEM_SUCCESS,data)
   } catch (error) { 
    commit(types.ITEM_FAIL);
   }; 
  },
  setViewItem({ commit }, payload){
    commit('setViewItem',payload)
  } 

}
